<template>
  <div>
    <Header>Авторизация</Header>
    <div class="container">
      <div class="row wrapper">
        <!-- PHONE CODE -->
        <section class="col-xl-12 col-12 wrapper-gray wrapper-confirm">
          <section class="phone-code">
            <h4>Введите код из СМС</h4>
            <form action="#" method="GET">
              <ul class="code-numbers">
                <li class="code-number">
                  <input v-on:keyup="changeInput($event)"
                         v-on:keydown="changeInput($event)"
                         v-on:keypress="changeInput($event)"
                         type="number"
                         name="code-1" />
                </li>
                <li class="code-number">
                  <input v-on:keyup="changeInput($event)"
                         v-on:keydown="changeInput($event)"
                         v-on:keypress="changeInput($event)"
                         type="number"
                         name="code-2" />
                </li>
                <li class="code-number">
                  <input v-on:keyup="changeInput($event)"
                         v-on:keydown="changeInput($event)"
                         v-on:keypress="changeInput($event)"
                         type="number"
                         name="code-3" />
                </li>
                <li class="code-number">
                  <input v-on:keyup="changeInput($event)"
                         v-on:keydown="changeInput($event)"
                         v-on:keypress="changeInput($event)"
                         type="number"
                         name="code-4" />
                </li>
              </ul>
              <router-link to="/booking" class="hide to-booking"></router-link>
              <section class="col-xl-12 col-12 wrapper-gray">
                <section class="buttons">
                  <router-link to="/booking"><button class="btn button-blue">OK</button></router-link>
                </section>
              </section>
            </form>
          </section>
          <section class="code-resend" v-on:click="resend($event)">
            Отправить еще раз<br>{{userphone ? userphone : phoneValue}}
          </section>
          <router-link to="/form">
            <section class="change-number">
              изменить номер телефона
            </section>
          </router-link>
          <section class="col-xl-12 col-12 wrapper-gray button-for-booking">
            <button class="btn button-blue" v-on:click="moveToBooking($event)">Подтвердить</button>
          </section>
        </section>
      </div>
      <Popup/>
    </div>
  </div>
</template>

<style>
.button-for-booking {
  display: none;
}

.confirm-form {
  background-color: #F6F7FB !important;
}

.buttons {
  display: none;
  margin-top: 2rem;
}

label.active {
  background-color: #2F80ED;
  border: 1px solid #fff;
  position: relative;
}

.button-blue {
    padding: 1rem 0px;
    width: 100%;
    text-align: center;
    background: #2F80ED;
    backdrop-filter: blur(81.6395px);
    border: none;
    border-radius: 36px;
    color: #fff;
    margin-bottom: 1rem;
  }

  .button-gray {
    padding: 1rem 0px;
    width: 100%;
    text-align: center;
    background: #C4C4C4;
    backdrop-filter: blur(81.6395px);
    border: none;
    border-radius: 36px;
    color: #fff;
    margin-bottom: 1rem;
  }

  .button-transpend {
    padding: 1rem 0px;
    width: 100%;
    text-align: center;
    background: transparent;
    backdrop-filter: blur(81.6395px);
    border: none;
    border-radius: 36px;
    color: #2F80ED;
    margin-bottom: 1rem;
    border: 3px solid #2F80ED;
  }

  .button-blue:active {
    background: #ff9500;
    color: #fff;
  }

.wrapper-confirm {
  padding-top: 2rem;
}

.wrapper-gray {
  background-color: #F6F7FB !important;
}

.hide {
  overflow: hidden;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0px;
  padding: 0px;
}

.phone-code {
  text-align: center;
}

.phone-code h4 {
  font-family: 'Avenir Next Cyr';
  font-size: 20px;
  line-height: 25px;
  margin: 1rem auto;
}
</style>

<script>

import Popup from '../components/popup.vue';
import $ from 'jquery';
import Header from '../components/header.vue';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'ConfirmForm',
  data() {
      return {

      };
  },
  metaInfo: {
      title: 'СМС',
      titleTemplate: '%s - Онлайн-запись MyClient',
      htmlAttrs: {
          lang: 'ru',
          amp: false
      }
  },
  mounted: function() {
    let vm = this;
    vm.phoneValue = localStorage.getItem('phone');
  },
  beforeCreate: function() {
    document.body.className = 'confirm-form';
  },
  methods: {
    changeInput: (event) => {
      let value = String(event.target.value);
      if(isNaN(value)) {
         event.preventDefault();
        return;
      }

      let numbers = value.split('');

      if(numbers.length > 1) {
        $(event.target).val('');

        for(var index in numbers) {
          index = Number(index);
          var number = numbers[index];
          var inputSelector = '[name="code-' + String(index + 1) + '"]';

          $(inputSelector).val(String(number).charAt(number.length - 1));
        }

        $(inputSelector).focus();
      }
      else {
        if(value) {
          if($(event.target).val() !== '') {
            $(event.target).val('');
          }

          $(event.target).val(String(value).charAt(value.length - 1));

          setTimeout(() => {
            let values = '';
            const parent = $(event.target).parent();

            if($(event.target).val() !== '') {
              parent.next().find('input').focus();
            } else {
              parent.prev().find('input').focus();
            }

            $('.code-numbers').find('input').each(function(index, element) {
              values += $(element).val();
            });

            if(String(values).length === 4) {
              $('.button-for-booking').fadeIn(300);
            } else {
              $('.button-for-booking').hide();
            }
          }, 100);
        }
      }

      $('[name^="code-"]').each(function(index, el) {
        $(el).val(String($(el).val()).charAt( String($(el).val()).length - 1 ));
      });
    },
    resend: function(event) {
      axios.post('/api/sms', {
        phone: this.userphone ? this.userphone : this.phoneValue,
      }).then((response) => {
        this.$noty.success("Мы отправили вам новый код");
      });
    },
    moveToBooking: function(event) {
      let vm = this;
      event.preventDefault();

      let values = '';
      $('.code-numbers').find('input').each(function(index, element) {
          values += $(element).val();
      });

      axios.post('/api/auth', {
        username: this.username,
        phone: this.userphone ? this.userphone : this.phoneValue,
        code: values,
        service: this.search,
        reminder: this.reminder,
        date: this.date,
        hour: this.hour,
        datetime: this.datetime,
        professionalId: window.professionalId ? window.professionalId : vm.professionalId,
        professionalName: this.professionalName,
        bookingId: window.bookingId ? window.bookingId : null,
        clientTimezone: this.clientTimezone,
        clientLang: this.clientLang,
        clientDevice: this.clientDevice
      }).then((response) => {
        if(response.data.status === 'error') {
          this.$noty.error("Код не подошел");
        } else {
          window.calendarUrl = response.data.calendarUrl;
          vm.sendForm();
        }
      });
    },
    findIdInServiceList(id) {
      const professionalServicesList = this.professionalServicesList;

      for(let index in professionalServicesList) {
        const service = professionalServicesList[index];
        if(service.id === id) {
          return service;
        }
      }

      return false;
    },
    sendForm() {
      let vm = this;

      let currentServices = [];
      const services = vm.services;
      if(window.professionalId || vm.professionalId) {
        for(let index in services) {
          let service = services[index];

          if(service) {
            let checkService = this.findIdInServiceList(index);

            if(checkService !== false) {
              currentServices.push({
                id: checkService.id,
                name: checkService.title,
                price: checkService.price,
                discount: checkService.discount,
                currency: checkService.currency,
                 durationIso: typeof checkService.duration !== 'undefined' ? checkService.duration : checkService.durationIso,
              });
            }
          }
        }
      }

      let datetime = moment(vm.date + ' ' + vm.hour)
        .utcOffset(0)
        .format('YYYY-MM-DDTHH:mm:ss');

      if (currentServices.length && (window.professionalId || vm.professionalId)) {
        axios.post('/api/send/form', {
          username: vm.username,
          phone: vm.userphone ? vm.userphone : vm.phoneValue,
          services: currentServices,
          reminder: vm.reminderList[vm.reminder].value,
          date: vm.date,
          hour: vm.hour,
          sum: vm.sum,
          hours: vm.hours,
          minutes: vm.minutes,
          currency: vm.currency,
          clientId: vm.clients,
          professionalName: vm.professionalName,
          datetime: datetime,
          professionalId: window.professionalId ? window.professionalId : vm.professionalId,
          bookingId: window.bookingId ? window.bookingId : null,

          clientTimezone: vm.clientTimezone,
          clientLang: vm.clientLang,
          clientDevice: vm.clientDevice
        }).then((sendFormResponse) => {
          this.$store.dispatch('startsCounDrop');
          if(sendFormResponse.data.status === 'error') {
            this.$noty.error("Во время создания букинга произошла ошибка");
            return;
          }

          this.$store.dispatch('hour', '');
          this.$store.dispatch('date', '');
          this.$store.dispatch('datetime', '');

          const result = sendFormResponse.data;

          if(typeof result.data !== 'undefined' && typeof result.data.id !== 'undefined') {
            localStorage.removeItem('vuex');
            vm.$store.dispatch('phone', vm.userphone ? vm.userphone : vm.phoneValue);
            window.location.href = '/booking/' + result.data.id + '#/booking/' + result.data.id;
          } else {
            localStorage.removeItem('vuex');
            window.location.href = '/booking/' + window.bookingId + '#/booking/' + window.bookingId;
          }
        });
      } else {
        window.location.href = '/booking/' + window.bookingId + '#/booking/' + window.bookingId;
      }
    }
  },
  components: {
    Header,
    Popup
  },
  computed: {
    username() {
      return this.$store.getters.username;
    },
    userphone() {
      return this.$store.getters.userphone;
    },
    phone() {
      return this.$store.getters.phone;
    },
    professionalId() {
      return this.$store.getters.professionalId;
    },
    professionalName() {
      return this.$store.getters.professionalName;
    },
    bookingId() {
      return this.$store.getters.bookingId;
    },
    reminder() {
      return this.$store.getters.reminder;
    },
    search() {
      return this.$store.getters.search;
    },
    services() {
      return this.$store.getters.services;
    },
    date() {
      return this.$store.getters.date;
    },
    clients() {
      return this.$store.getters.client;
    },
    clientId() {
      return typeof this.$store.getters.client[0] !== 'undefined' ? this.$store.getters.client[0].id : null;
    },
    hour() {
      return this.$store.getters.hour;
    },
    datetime() {
      return this.$store.getters.datetime;
    },
    clientTimezone() {
      return this.$store.getters.clientTimezone;
    },
    clientLang() {
      return this.$store.getters.clientLang;
    },
    clientDevice() {
      return this.$store.getters.clientDevice;
    },
    professionalServicesList() {
      return this.$store.getters.professionalServicesList;
    },
    currency() {
      return this.$store.getters.currency;
    },
    sum() {
      return this.$store.getters.sum;
    },
    hours() {
      return this.$store.getters.hours;
    },
    minutes() {
      return this.$store.getters.minutes;
    },
    reminderList() {
      return this.$store.getters.reminderList;
    },
  },
};
</script>
